import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteSmriqCredential, upsertSmriqCredential } from '../services/smriqCredentials';
import type { SmriqCredentialPayload } from '../services/smriqCredentials';
import { smriqCredentialKeys } from './useSmriqCredentialQuery';

export const useSmriqCredentialMutation = (productId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: SmriqCredentialPayload) => upsertSmriqCredential(productId, payload),
        // The mutation cache keeps `state.variables`/`state.error` (plaintext api_key,
        // and a rejected error carrying the serialised request body) across success/error.
        gcTime: 0,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: smriqCredentialKeys.detail(productId) });
        },
    });
};

export const useSmriqCredentialDeleteMutation = (productId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => deleteSmriqCredential(productId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: smriqCredentialKeys.detail(productId) });
        },
    });
};
